import { render, staticRenderFns } from "./LoadCard.vue?vue&type=template&id=77be7081"
import script from "./LoadCard.vue?vue&type=script&lang=js"
export * from "./LoadCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports